module.exports = __webpack_public_path__ + "img/logo_icon.d9af92cd.png";